import { Allocation, Identifiable } from "@planzone/dto";

function isLastIncompleteAllocation(
  allocations: Identifiable<Allocation>[],
  allocation: Identifiable<Allocation>,
): boolean {
  const nonCompleteAllocations = allocations.filter(
    (a) => a.percentComplete !== 100,
  );
  return (
    nonCompleteAllocations.filter((all) => {
      all.uuid === allocation.uuid;
    }) &&
    nonCompleteAllocations.length === 1 &&
    allocation.percentComplete !== 100
  );
}

export { isLastIncompleteAllocation };
